import Glide from '@glidejs/glide';
import glideConfig from '../util/glideConfig.js';

/**
* Logo Slider Class
*
* This class provides client-side funcitonality to Logo Slider blocks
* NOTE: This class uses Glide JS for carousels
*
* @package  Manco Automatics
* @author   Tom Kellock
* @access   public
* @see      https://glidejs.com/docs/api/
*/
class LogoSlider
{
  /**
  * Constructor function
  *
  * Function that performs actions upon initiation of this class
  *
  * This function loops through each logo slider block and finds any carousels.
  * If there are any carousels, each carousel is passed to the slide function
  *
  * @param    array  grids   Array containing all of the testimonial blocks
  * @return   void
  * @access   public
  */
  constructor(logoSliders)
  {
    logoSliders.forEach((slider) => {
      const carousel = slider.querySelector('.carousel');

      if (carousel) {
        this._slide(carousel);
      }
    });
  }

  /**
  * Slide function
  *
  * Function that performs the sliding animation of the selected carousel
  *
  * @param    object    Object containing the selected carousel element
  * @uses     Glide::mount() to "mount" the slider to an element
  * @return   void
  * @access   private
  */
  _slide(carousel) {
    new Glide(carousel, {
      type:                 'carousel',
      perView:              4,
      gap:                  24,
      breakpoints: {
        992: {
          autoplay: 3000,
          perView: 2,
        },
      },
      classes:              glideConfig.classes,
      animationTimingFunc:  glideConfig.animationTimingFunc,
      animationDuration:    glideConfig.animationDuration,
    }).mount();
  }
}

export default LogoSlider;
